// extracted by mini-css-extract-plugin
export default {"container":"pMr1Ys","backgroundImage":"Clv1uY","mobileBackgroundImage":"Qqh1pD","title":"POc4lc","stats":"ZrYAhT","value":"rKHw37","valueContainer":"DZGLOJ","description":"Tu1wlH"};